module.exports = __webpack_public_path__ + "img/full-darkwaters-2.c36d292d.jpg";